const MessageComments = ({message})=>{
    if(!message.comments  || message.comments.length ===0) return <div></div>
return <>
<div>&nbsp;</div>
<hr />
<h3>תגובות</h3>
    { message.comments?.length > 0 && message.comments.map(comment=> <div key={comment._id} > <br/> ← {comment.name} ({comment.username})  {comment.complete?'-נצפה-':'לא נצפה'}  <br /> 🕑︎ {comment.date.toString().slice(0,10)} <br/> &nbsp;&nbsp;&nbsp;&nbsp; {comment.title} </div>)}
    </>

}
export default MessageComments